import { useToast } from "@/hooks/use-toast";
import { useAuthStore } from "@/store/authStore";
import { useEnterpriseStore } from "@/store/enterpriseStore";
import { useFreelancerStore } from "@/store/freelancerStore";
import { useUserStore } from "@/store/userStore";
import { useNavigate } from "react-router-dom";
import { Axios } from "./axios";


export const handleLogout = async () => {
    const navigate = useNavigate();
    const { toast } = useToast();
    const { logout: userLogout } = useUserStore();
    const { logout: authLogout } = useAuthStore();
    const { clearFreelancerProfile } = useFreelancerStore();
    const { clearEnterpriseProfile } = useEnterpriseStore();
  try {
    const response = await Axios.post("/api/auth/logout");
    navigate("/");
    toast({
      title: "Logged out",
      description: "You have been logged out successfully",
      variant: "default",
    });
    authLogout();
    userLogout();
    clearFreelancerProfile();
    clearEnterpriseProfile();
  } catch (error) {
    toast({
      title: "Logout failed",
      description: "An error occurred while logging out. Please try again.",
      variant: "destructive",
    });
  }
};
